module.exports = __webpack_public_path__ + "static/flags/CG-2cb3f6f76ff638ad92789989662c29bf.gif";